module.exports = __webpack_public_path__ + "img/blue_119.58236dc1.png";